import { Language } from "@cnx/common";
import api from "services/api";

class LanguageService {
  static getLanguages = async () => {
    const { data } = await api.get<Language[]>("/languages");
    return data;
  };
}

export default LanguageService;
